module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"apply_text":"Weight will be applied to all products in this page"},"id":{"apply_text":"Bobot ini akan diterapkan ke semua produk di halaman ini"}}')
  delete Component.options._Ctor
}
